export default __webpack_public_path__ + "static/img-tac-graph-44c1eb74520c768fdf1b96610b4c33ec.png";